const attendanceLevels = {
  veryLow: 'red-state',
  low: 'orange-state',
  medium: 'yellow-state',
  high: 'green-state',
}

const SymbolsClass = (predictPercent) => {
  let className
  if (predictPercent <= 25) {
      className = attendanceLevels.veryLow
  } else if (predictPercent > 25 && predictPercent <= 50) {
      className = attendanceLevels.low
  } else if (predictPercent > 50 && predictPercent <= 75) {
      className = attendanceLevels.medium
  } else if (predictPercent > 75) {
      className = attendanceLevels.high
  }
  return (
      <div className={className}/>
  )
}

export default SymbolsClass;